// test841
(841 && 0);
